import React from 'react';
import { Ic } from './Icons';
import { ACCENT, FONT } from '../lib/tokens';

const TABS = [
  { label: 'Home', Icon: Ic.Home },
  { label: 'Schedule', Icon: Ic.Calendar },
  { label: 'Parking Lot', Icon: Ic.Lightbulb },
  { label: 'Attendees', Icon: Ic.People },
];

export default function TabBar({ activeTab, setActiveTab, onAITap }) {
  return (
    <div
      style={{
        height: 80,
        background: 'rgba(14,20,40,0.98)',
        borderTop: '1px solid rgba(255,255,255,0.07)',
        display: 'flex',
        alignItems: 'flex-start',
        padding: '10px 4px 0',
        flexShrink: 0,
        position: 'relative',
      }}
    >
      <button
        onClick={onAITap}
        style={{
          position: 'absolute',
          right: 14,
          bottom: 82,
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: ACCENT,
          border: 'none',
          borderRadius: 24,
          padding: '9px 15px',
          color: '#fff',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: FONT,
          boxShadow: `0 4px 18px ${ACCENT}70, 0 2px 6px rgba(0,0,0,0.3)`,
          letterSpacing: '0.01em',
          whiteSpace: 'nowrap',
          zIndex: 20,
        }}
      >
        <Ic.Spark size={13} color="#fff" /> Ask ELX AI
      </button>
      {TABS.map(({ label, Icon }, i) => (
        <button
          key={i}
          onClick={() => setActiveTab(i)}
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px 2px',
          }}
        >
          <Icon
            size={22}
            color={activeTab === i ? ACCENT : 'rgba(255,255,255,0.28)'}
            filled={activeTab === i}
          />
          <span
            style={{
              fontSize: 9.5,
              fontWeight: activeTab === i ? 600 : 400,
              color: activeTab === i ? ACCENT : 'rgba(255,255,255,0.28)',
              fontFamily: FONT,
              letterSpacing: '0.01em',
            }}
          >
            {label}
          </span>
        </button>
      ))}
    </div>
  );
}
